import {
  Icon,
  type ListItemProps,
  TopNavigation,
} from "@studio3t/generic-components";
import { useMemo } from "react";
import { useAuth } from "@/auth";

function getDisplayName(
  firstName: string,
  lastName: string,
  username: string,
): string {
  const full = [firstName, lastName].filter(Boolean).join(" ");
  return full || username;
}

/** The signed-in user's menu on the top bar: the library's user menu fed
 *  from the auth session, with the one entry the bridge has — Log out. */
export function UserMenu() {
  const { user, isAuthenticated, logout } = useAuth();

  const items: ListItemProps[][] = useMemo(
    () => [
      [
        {
          id: "logout",
          label: "Log out",
          type: "text",
          value: "logout",
          leadingIcon: Icon.Logout,
          onClick: logout,
        },
      ],
    ],
    [logout],
  );

  if (!isAuthenticated || !user) return null;

  return (
    <TopNavigation.UserMenu
      name={getDisplayName(user.firstName, user.lastName, user.username)}
      email={user.email}
      items={items}
    />
  );
}
